export default __webpack_public_path__ + "static/media/groovy-cfs.a805fb7d.mp4";